let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bsnnn")).then(() => parcelRequire('eKy3s'));